<div
  #canvas
  class="lp-canvas-renderer"
  style="position: relative; display: block; height: 100%; width: 100%; overflow: hidden; user-select: none"
  (wheel)="$event.preventDefault()"
>
  <app-canvas-scroller [size]="size()" style="position: absolute; width: 100%; height: 100%" (panned)="handlePanned($event)" />

  <div class="elements" style="position: absolute; inset: 0; isolation: isolate; pointer-events: none">
    @for (el of sanitizedElements(); track el.uid) {
      @let bounds = getElementBounds(el);
      <lp-canvas-element
        [el]="el"
        [canvasCtx]="contexts.get(el.uid)"
        [style]="{
          display: 'block',
          position: 'absolute',
          left: 100 * bounds.position[0] + '%',
          top: 100 * bounds.position[1] + '%',
          width: 100 * bounds.size[0] + '%',
          height: 100 * bounds.size[1] + '%',
        }"
      />
    }
  </div>

  <lp-canvas-renderer-arrows [origin]="origin()" [size]="size()" />
</div>
